<!-- Center -->
<div [class]="styleClass()" aria-label="conversation-logs-container">
  @if (!showSkeleton()) {
    <p-scrollPanel
      styleClass="pr-1 -mr-1 pb-1"
      [style]="{ height: height() }"
      #scrollContainer
      aria-label="conversation-scroll-panel"
    >
      @for (
        group of groupedConversations.value;
        track group;
        let groupIndex = $index
      ) {
        <!-- Divider -->
        <div
          class="sticky top-0 text-center surface-100 relative z-2 pb-2 mb-2 px-3 my-0"
          [attr.aria-label]="'conversation-date-divider-' + groupIndex"
        >
          <span
            class="text-xs text-600 relative z-2 surface-100 px-2 uppercase"
            [attr.aria-label]="'conversation-date-' + groupIndex"
            >{{ group.date | date: 'fullDate' }}</span
          >
          <p-divider
            [align]="'center'"
            styleClass="my-0 absolute top-50 left-50 translate-middle"
            [attr.aria-label]="'date-divider-' + groupIndex"
          />
        </div>
        <!-- Divider -->
        @for (
          activity of getSortedConversations(group.messages);
          track activity;
          let last = $index;
          let activityIndex = $index
        ) {
          <!-- Add class 'conversation-message' to each message container -->
          <div
            class="conversation-message"
            [id]="last ? 'lastMessage' : ''"
            [attr.aria-label]="
              'conversation-message-' + groupIndex + '-' + activityIndex
            "
          >
            <!-- OutGoing Message -->
            @if (
              activity.direction &&
              (activity.direction === directionEnum.Outgoing ||
                activity.direction.toString() ===
                  directionEnum[directionEnum.Outgoing])
            ) {
              <div
                class="flex align-items-end justify-content-end mb-3 text-sm px-3 md:pr-3"
                [attr.aria-label]="
                  'outgoing-message-' + groupIndex + '-' + activityIndex
                "
              >
                <div>
                  <div class="flex align-items-center justify-content-end">
                    @if (
                      getStaffDetails(
                        activity.staff_id
                          ? activity.staff_id
                          : activity.updated_by
                      ) | async;
                      as staffDetail
                    ) {
                      <strong
                        class="block font-bold"
                        [attr.aria-label]="
                          'staff-name-' + groupIndex + '-' + activityIndex
                        "
                        >{{ staffDetail?.name | titlecase }}</strong
                      >
                    }
                  </div>
                  <div
                    class="bg-blue-50 shadow-2 my-2 border-round-left-xl border-round-top-xl p-3"
                    style="overflow-wrap: break-word; word-break: break-word"
                    [innerHTML]="getInteractionContent(activity)"
                    [attr.aria-label]="
                      'outgoing-message-content-' +
                      groupIndex +
                      '-' +
                      activityIndex
                    "
                  ></div>
                  <div class="flex align-items-center justify-content-end">
                    <span
                      class="block text-600 text-xxs"
                      [attr.aria-label]="
                        'message-time-' + groupIndex + '-' + activityIndex
                      "
                      >{{
                        activity.log_date | datetimeformat: 'shortTime'
                      }}</span
                    >
                    <!-- Status Indicator -->
                    @if (shouldShowStatusIndicator(activity)) {
                      <i
                        [class]="getStatusIcon(activity)"
                        class="ml-1"
                        [pTooltip]="getStatusTooltip(activity)"
                        [attr.aria-label]="
                          'message-status-' + groupIndex + '-' + activityIndex
                        "
                      ></i>
                    }
                    <!-- Default sent icon for messages without status -->
                    @if (!shouldShowStatusIndicator(activity)) {
                      <img
                        width="16"
                        class="ml-1"
                        src="/assets/img/icons/icon-tick.svg"
                        alt="Message sent"
                        [attr.aria-label]="
                          'message-sent-icon-' +
                          groupIndex +
                          '-' +
                          activityIndex
                        "
                      />
                    }
                  </div>
                </div>
                <div
                  class="relative ml-3 mb-3 pb-1"
                  [attr.aria-label]="
                    'staff-avatar-' + groupIndex + '-' + activityIndex
                  "
                >
                  @if (
                    getStaffDetails(
                      activity.staff_id
                        ? activity.staff_id
                        : activity.updated_by
                    ) | async;
                    as staffDetail
                  ) {
                    @if (staffDetail?.ff_picture) {
                      <p-avatar
                        [image]="staffDetail.ff_picture"
                        styleClass="mr-2"
                      />
                    }
                    @if (!staffDetail?.ff_picture) {
                      <p-avatar
                        styleClass="mr-2"
                        [label]="staffDetail?.name | titlecase | shortName"
                      />
                    }
                  }
                  <span
                    class="absolute right-0 top-0 -mr-2 -mt-2 text-white flex align-items-center justify-content-center p-1 border-round"
                    [ngClass]="getClass(activity.interaction_type)"
                    [attr.aria-label]="
                      'interaction-type-icon-' +
                      groupIndex +
                      '-' +
                      activityIndex
                    "
                  >
                    <i [class]="getIcons(activity.interaction_type)"></i>
                  </span>
                </div>
              </div>
            }
            <!-- OutGoing Message -->
            <!-- Incoming Message -->
            @if (
              activity.direction &&
              (activity.direction === directionEnum.Incoming ||
                activity.direction.toString() ===
                  directionEnum[directionEnum.Incoming])
            ) {
              <div
                class="flex align-items-end mb-3 text-sm px-3"
                [ngClass]="{
                  'bg-yellow-200 px-5 py-3': showHighlightedMsg(activity),
                }"
                [attr.aria-label]="
                  'incoming-message-' + groupIndex + '-' + activityIndex
                "
              >
                <div class="relative mr-3 mb-3">
                  @if (client() && client().image) {
                    <p-avatar
                      [image]="client().image"
                      shape="circle"
                      [attr.aria-label]="
                        'client-avatar-' + groupIndex + '-' + activityIndex
                      "
                    />
                  }
                  @if (client() && !client().image) {
                    @if (!client().image) {
                      <p-avatar
                        shape="circle"
                        [label]="client().full_name | titlecase | shortName"
                        [attr.aria-label]="
                          'client-avatar-' + groupIndex + '-' + activityIndex
                        "
                      />
                    }
                  }
                  <span
                    class="absolute left-0 top-0 -ml-3 text-white flex align-items-center justify-content-center p-1 border-round"
                    [ngClass]="getClass(activity.interaction_type)"
                    [attr.aria-label]="
                      'interaction-type-icon-' +
                      groupIndex +
                      '-' +
                      activityIndex
                    "
                  >
                    <i [class]="getIcons(activity.interaction_type)"></i>
                  </span>
                </div>
                <div>
                  <strong
                    class="block font-bold"
                    [attr.aria-label]="
                      'client-name-' + groupIndex + '-' + activityIndex
                    "
                    >{{ client().full_name }}</strong
                  >
                  <div
                    class="bg-primary shadow-2 my-2 border-round-right-xl border-round-top-xl p-3"
                    style="overflow-wrap: break-word; word-break: break-word"
                    [innerHTML]="getInteractionContent(activity)"
                    [attr.aria-label]="
                      'incoming-message-content-' +
                      groupIndex +
                      '-' +
                      activityIndex
                    "
                  ></div>
                  <div class="flex align-items-center">
                    <span
                      class="block text-600 text-xxs"
                      [attr.aria-label]="
                        'message-time-' + groupIndex + '-' + activityIndex
                      "
                      >{{
                        activity.log_date | datetimeformat: 'shortTime'
                      }}</span
                    >
                  </div>
                </div>
              </div>
            }
            <!-- Incoming Message -->
            <!-- CALL -->
            <!-- <div *ngIf="activity && activity.direction == null && activity.interaction_type =='Call' " class="flex align-items-center justify-content-center text-600 text-xs my-4">
            <i class="fa fa-phone-slash mr-2"></i>
            <span>Call • 0s</span>
          </div> -->
            @if (
              activity &&
              activity.direction === null &&
              activity.interaction_type === 'Call'
            ) {
              <div class="flex align-items-end mb-3 text-sm px-3">
                <div class="relative mr-3 mb-3">
                  @if (
                    getStaffDetails(
                      activity.staff_id
                        ? activity.staff_id
                        : activity.updated_by
                    ) | async;
                    as staffDetail
                  ) {
                    @if (staffDetail?.ff_picture) {
                      <p-avatar
                        [image]="staffDetail.ff_picture"
                        styleClass="mr-2"
                      />
                    }
                    @if (!staffDetail?.ff_picture) {
                      <p-avatar
                        styleClass="mr-2"
                        [label]="staffDetail?.name | titlecase | shortName"
                      />
                    }
                  }
                  <span
                    class="surface-900 absolute left-0 top-0 -ml-3 text-white flex align-items-center justify-content-center p-1 border-round"
                    ><i class="fa fa-phone-slash text-sm"></i
                  ></span>
                </div>
                <div>
                  @if (
                    getStaffDetails(
                      activity.staff_id
                        ? activity.staff_id
                        : activity.updated_by
                    ) | async;
                    as staffDetail
                  ) {
                    <strong class="block font-bold">{{
                      staffDetail?.name | titlecase
                    }}</strong>
                  }
                  <div
                    class="border-1 border-300 my-2 border-round-right-xl border-round-top-xl"
                  >
                    <div
                      class="border-bottom-1 border-300 text-600 py-2 px-3 flex align-items-center"
                    >
                      <span class="text-xs uppercase font-bold text-600">{{
                        'OUTCOME.CALLOUTCOME.CALL-OUTCOME' | translate
                      }}</span>
                      <span
                        class="p-1 border-round text-center flex align-items-center text-xxs bg-cyan-500 text-white font-bold ml-2"
                      >
                        @if (getCallOutcome(activity.outcome); as content) {
                          <i [class]="content.icon"></i>
                          <span>{{ content.name }}</span>
                        }
                      </span>
                    </div>
                    <div class="p-3">
                      <div class="text-xs uppercase font-bold text-600 mb-1">
                        {{ 'OUTCOME.CALLOUTCOME.NOTES' | translate }}:
                      </div>
                      <div
                        style="
                          overflow-wrap: break-word;
                          word-break: break-word;
                        "
                      >
                        {{ activity.notes }}
                      </div>
                    </div>
                  </div>
                  <div class="flex align-items-center">
                    <span class="block text-600 text-xxs">{{
                      activity.log_date | datetimeformat: 'shortTime'
                    }}</span>
                  </div>
                </div>
              </div>
            }
            <!-- CALL -->
            <!-- TOUR -->
            @if (
              activity &&
              activity.direction === null &&
              activity.interaction_type === 'Tour'
            ) {
              <div class="flex align-items-end mb-3 text-sm px-3">
                <div class="relative mr-3 mb-3">
                  @if (
                    getStaffDetails(
                      activity.staff_id
                        ? activity.staff_id
                        : activity.updated_by
                    ) | async;
                    as staffDetail
                  ) {
                    @if (staffDetail?.ff_picture) {
                      <p-avatar
                        [image]="staffDetail.ff_picture"
                        styleClass="mr-2"
                      />
                    }
                    @if (!staffDetail?.ff_picture) {
                      <p-avatar
                        styleClass="mr-2"
                        [label]="staffDetail?.name | titlecase | shortName"
                      />
                    }
                  }
                  <!-- <span class="surface-900 absolute left-0 top-0 -ml-3 text-white flex align-items-center justify-content-center p-1 border-round"><i class="fa fa-phone-slash text-sm"></i></span> -->
                </div>
                <div>
                  @if (
                    getStaffDetails(
                      activity.staff_id
                        ? activity.staff_id
                        : activity.updated_by
                    ) | async;
                    as staffDetail
                  ) {
                    <strong class="block font-bold">{{
                      staffDetail?.name | titlecase
                    }}</strong>
                  }
                  <div
                    class="border-1 border-300 my-2 border-round-right-xl border-round-top-xl"
                  >
                    <div
                      class="border-bottom-1 border-300 text-600 py-2 px-3 flex align-items-center"
                    >
                      <span class="text-xs uppercase font-bold text-600">{{
                        'OUTCOME.TOUROUTCOME.MEETING-OUTCOME' | translate
                      }}</span>
                      <span
                        class="p-1 border-round text-center flex align-items-center text-xxs bg-cyan-500 text-white font-bold ml-2"
                      >
                        @if (getTourOutcome(activity.outcome); as content) {
                          <i [class]="content.icon"></i>
                          <span>{{ content.name }}</span>
                        }
                      </span>
                    </div>
                    <div class="p-3">
                      <div class="text-xs uppercase font-bold text-600 mb-1">
                        {{ 'OUTCOME.TOUROUTCOME.NOTES' | translate }}:
                      </div>
                      <div
                        style="
                          overflow-wrap: break-word;
                          word-break: break-word;
                        "
                      >
                        {{ activity.notes }}
                      </div>
                    </div>
                  </div>
                  <div class="flex align-items-center">
                    <span class="block text-600 text-xxs">{{
                      activity.log_date | datetimeformat: 'shortTime'
                    }}</span>
                  </div>
                </div>
              </div>
            }
            <!-- TOUR -->
          </div>
        }
      }
    </p-scrollPanel>
  }

  <!-- Messages Skeleton -->
  @if (showSkeleton()) {
    <p-scrollPanel
      styleClass="pr-3 -mr-3"
      [style]="{ height: '64vh' }"
      aria-label="conversation-skeleton"
    >
      <!-- Reply -->
      <div
        class="flex align-items-end justify-content-end mb-3 text-sm px-3"
        aria-label="skeleton-reply"
      >
        <div class="w-full">
          <strong class="flex justify-content-end"
            ><p-skeleton
              width="4rem"
              height="1rem"
              aria-label="skeleton-staff-name"
          /></strong>
          <div
            class="bg-blue-50 shadow-2 my-2 border-round-left-xl border-round-top-xl p-3"
          >
            <p-skeleton
              width="100%"
              height="1rem"
              aria-label="skeleton-message-line-1"
            />
            <p-skeleton
              width="100%"
              height="1rem"
              styleClass="mt-1"
              aria-label="skeleton-message-line-2"
            />
          </div>
          <strong class="flex justify-content-end mt-1"
            ><p-skeleton width="4rem" height="1rem" aria-label="skeleton-time"
          /></strong>
        </div>
        <div class="relative ml-3 mb-3 pb-1">
          <p-skeleton
            width="2rem"
            height="2rem"
            shape="circle"
            aria-label="skeleton-avatar"
          />
        </div>
      </div>
      <!-- Reply -->
      <!-- Divider -->
      <div class="relative text-center my-3" aria-label="skeleton-divider">
        <p-skeleton
          width="10rem"
          height="1rem"
          styleClass="relative z-1 mx-auto"
          aria-label="skeleton-date"
        />
        <p-divider
          align="center"
          styleClass="my-0 absolute top-50 left-50 translate-middle"
          aria-label="skeleton-divider-line"
        />
      </div>
      <!-- Divider -->
      <!-- Message -->
      <div
        class="flex align-items-end mb-3 text-sm px-3"
        aria-label="skeleton-message-1"
      >
        <div class="relative mr-3 mb-3">
          <p-skeleton
            width="2rem"
            height="2rem"
            shape="circle"
            aria-label="skeleton-avatar-1"
          />
        </div>
        <div class="w-full">
          <strong class="block font-bold"
            ><p-skeleton
              width="4rem"
              height="1rem"
              aria-label="skeleton-name-1"
          /></strong>
          <div
            class="bg-blue-50 shadow-2 my-2 border-round-right-xl border-round-top-xl p-3"
          >
            <p-skeleton
              width="100%"
              height="1rem"
              aria-label="skeleton-message-line-1-1"
            />
            <p-skeleton
              width="100%"
              height="1rem"
              styleClass="mt-1"
              aria-label="skeleton-message-line-2-1"
            />
          </div>
          <strong class="mt-1"
            ><p-skeleton
              width="4rem"
              height="1rem"
              aria-label="skeleton-time-1"
          /></strong>
        </div>
      </div>
      <!-- Message -->
      <!-- Message -->
      <div
        class="flex align-items-end mb-3 text-sm px-3"
        aria-label="skeleton-message-2"
      >
        <div class="relative mr-3 mb-3">
          <p-skeleton
            width="2rem"
            height="2rem"
            shape="circle"
            aria-label="skeleton-avatar-2"
          />
        </div>
        <div class="w-full">
          <strong class="block font-bold"
            ><p-skeleton
              width="4rem"
              height="1rem"
              aria-label="skeleton-name-2"
          /></strong>
          <div
            class="bg-blue-50 shadow-2 my-2 border-round-right-xl border-round-top-xl p-3"
          >
            <p-skeleton
              width="100%"
              height="1rem"
              aria-label="skeleton-message-line-1-2"
            />
            <p-skeleton
              width="100%"
              height="1rem"
              styleClass="mt-1"
              aria-label="skeleton-message-line-2-2"
            />
          </div>
          <strong class="mt-1"
            ><p-skeleton
              width="4rem"
              height="1rem"
              aria-label="skeleton-time-2"
          /></strong>
        </div>
      </div>
      <!-- Message -->
    </p-scrollPanel>
  }
  <!-- Messages Skeleton -->
</div>
<!-- Add Comment -->
<!-- <reply *ngIf="isTwoWayNotificationEnabled" [client]="client" [lastInteraction]="lastInteraction" [tenantId]="tenantId" (newInteraction)="getNewInteraction($event)"></reply> -->
<!-- Add Comment -->
